import { render } from "./ModalPreviewGroupMultipleOption.vue?vue&type=template&id=0c20945a&scoped=true"
import script from "./ModalPreviewGroupMultipleOption.vue?vue&type=script&lang=js"
export * from "./ModalPreviewGroupMultipleOption.vue?vue&type=script&lang=js"

import "./ModalPreviewGroupMultipleOption.vue?vue&type=style&index=0&id=0c20945a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c20945a"]])

export default __exports__